import { render, staticRenderFns } from "./DropdownCard.vue?vue&type=template&id=534d6bca&scoped=true"
import script from "./DropdownCard.vue?vue&type=script&lang=js"
export * from "./DropdownCard.vue?vue&type=script&lang=js"
import style0 from "./DropdownCard.vue?vue&type=style&index=0&id=534d6bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534d6bca",
  null
  
)

export default component.exports